import { render, staticRenderFns } from "./WonderYjjPopular.vue?vue&type=template&id=181746c0"
import script from "./WonderYjjPopular.vue?vue&type=script&lang=js"
export * from "./WonderYjjPopular.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports